import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// Component
import Checkbox from "components/Checkbox";
import ButtonAction from "components/ButtonAction";

const TrustedIdentityProviderTable = (props) => {
  const {
    tableRef,
    stickyStyle,
    tableHeader,
    currentMetaDataSetList,
    changeModalStatus,
    checkedAllState,
    toggleCheckedAll,
    toggleChecked,
    selectMetadataSetCallback,
    handleDelete
  } = props;

  const { t } = useTranslation();

  return (
    <Table responsive striped hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>
            <Checkbox
              id="rl-th-idp"
              type='checkbox'
              checked={checkedAllState()}
              onChange={toggleCheckedAll}
            />
          </th>
          {tableHeader()}
          <th>
            {t('06df33001c')}
          </th>
        </tr>
      </thead>
      <tbody>
        {currentMetaDataSetList && currentMetaDataSetList.map((metaDataSet, index) => {
          return (
            <tr key={index}>
              <td>
                <Checkbox
                  id={`rl-cb-idp-${index}`}
                  type='checkbox'
                  checked={metaDataSet.checked === true}
                  onChange={() => toggleChecked(index)}
                />
              </td>
              <td>{metaDataSet.name}</td>
              <td>{metaDataSet.loginUrl}</td>
              <td>{metaDataSet.issuerUri}</td>
              <td>{metaDataSet.idpCertFileName}</td>
              <td>{metaDataSet.logoutUrl}</td>
              <td>{metaDataSet.idpCertFingerprint}</td>
              <td className={'table-action-td'}>
                <ButtonAction
                  label="7e77616685"
                  iconClassName="icon-edit"
                  onClick={() => {
                    selectMetadataSetCallback(metaDataSet);
                    changeModalStatus('addAndEdit', true);
                  }}
                />
                <ButtonAction
                  label="ce64bbe3ba"
                  iconClassName="icon-trash"
                  onClick={() => {
                    handleDelete(metaDataSet.id);
                    changeModalStatus('delete', true);
                  }}
                />
              </td>
            </tr>
          )
        })}
        {currentMetaDataSetList.length === 0 && (
          <tr>
            <td colSpan="8" className="no-data">
              {t('ad01242a61')}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default TrustedIdentityProviderTable;
